import { IWidgetDefinition, IWidget, SJPluginSettings, IDataResponse, IUrlParamWidget } from '../../common/core';
import { ISearchSettings, ISearchState } from './search.settings';

var loadedAutocomplete = false;
var loadAutocomplete = () => {
    if (loadedAutocomplete) {
        return;
    }
    require('sjautocomplete/dist/jquery.sjautocomplete');
    loadedAutocomplete = true;
};

var styles = require("./search.scss").toString();
var template = require("./search.html");

export class SearchData implements IUrlParamWidget {
    selected = false;
    lastQuery = null;
    showAc = false;
    $textarea: any;
    refreshTimeout: any;
    textareaPlugin: SJPluginSettings;
    mouseover: boolean = false;
    tooltipType: string;
    tooltipText: string;
    suggest: {
        value: string,
        highlighted: string
    }[];
    acInputSelector = 'sjsf-container';

    suggestionWasClosed?: true;

    // final settings
    autocompleteSettings: any;

    sendInitialSearchTrackEvent?: boolean;

    constructor(public widget: IWidget<SearchData, ISearchSettings, ISearchState>) {
        this.init();
    }

    get $el() {
        return window['SJSearchLoader'].jQuery && window['SJSearchLoader'].jQuery(this.widget.widgetDiv.element.nativeElement).find(`.${this.acInputSelector}`);
    }

    init() {
        var self = this;

        this.textareaPlugin = {
            afterViewInit(plugin) {
                self.widget.service.waitForJQuery().then(jQuery => {
                    self.$textarea = jQuery(plugin.$element.nativeElement);
                    self.refreshTextareaSize();
                    self.initAutocomplete();
                }, () => {
                    console.log('Search Widget: jQuery is not available.');
                });
            }
        }
    }

    setAcValue(settings, val, reload, validate) {
        this.widget.state.searchString = val;
        var runSearch = false;
        if (!this.widget.settings || (settings.mode !== 'advanced' && settings.mode !== 'minimal') || reload) {
            if (!val || (val && /[^:=\(<>]$/g.test(val))) { // not run search automatically if query is not valid
                this.onSearch();
                runSearch = true;
            }
        }

        if (!runSearch) {
            var changed = this.refreshModeState();
            if (changed) {
                this.widget.service.setState(true);
            }
        }

        this.refreshTextareaSizeWithTimeout();
    }

    refreshModeState() {
        var stateModeChanged;
        var sjquerybar = this.$el.data('sjquerybar');
        if (sjquerybar) {
            var queryBarMode = sjquerybar.getMode();
            var modeSwitchDisabled = sjquerybar.isModeSwitchDisabled();

            var stateMode;
            if (modeSwitchDisabled) {
                // no need in stateMode (as filters not avaialbe and only sjql mode available)
            } else {
                if (queryBarMode == 'sjql') {
                    stateMode = queryBarMode;
                } else {
                    // no need in stateMode as filters should be shown by default (if available)
                }
            }
            if (this.widget.state.mode !== stateMode) {
                if (stateMode) {
                    this.widget.state.mode = stateMode;
                } else {
                    delete this.widget.state.mode;
                }
                stateModeChanged = true;
            }
        }
        return stateModeChanged;
    }

    isAutocompleteDisabled() {
        return this.widget.settings.disableAutocomplete || this.isNonSeriesRequests();
    }

    isNonSeriesRequests() {
        return this.widget.service.search_api_path && this.widget.service.search_api_path != "/series";
    }

    initAutocomplete() {
        this.destroyAutocomplete();
        var settings = this.widget.settings;

        // if (!settings.types || settings.types.length) {
        var authSettings = this.widget.service.appProvider.options.auth;

        var types = settings.types ? settings.types.slice() : ['field', 'fieldvalue'];
        if ((settings.mode == 'advanced' || settings.mode == 'minimal') && settings.pointsContext) {
            types.push('@');
        }

        var extra_get_params = {
            types: types.join(',')
        };

        if (settings.types && settings.types.indexOf('text') != -1) {
            extra_get_params['text_style'] = settings.textStyle || 'phraseprefix';
            if (settings.textFields && settings.textFields.length) {
                extra_get_params['text_fields'] = settings.textFields.join(',');
            }
            if (typeof settings.textFragmentSize == 'number') {
                extra_get_params['text_fragment_size'] = settings.textFragmentSize;
            }
        }

        this.widget.service.waitForJQuery().then(jQuery => {

            loadAutocomplete();

            var autocompleteSettings = {
                get_param: 'query',
                server: authSettings.server == '/' ? location.origin : authSettings.server,
                get_credentials: authSettings.getCredentials,
                set_value: (val, reload, validate) => {
                    this.widget.service['zone'].run(() => {
                        this.setAcValue(settings, val, reload, validate);
                    });
                },
                onShow: (show) => {
                    this.showAc = show;
                },
                format_query: (q) => this.formatQuery(q),
                extra_get_params: extra_get_params,
                show_hints: settings.showHints,
                hotkeys: true,
                suggest: this.widget.settings.suggest,
                min_length: this.widget.settings.minLength,
                suggestionClosed: () => {
                    this.suggestionClosed();
                }
            };

            if (this.isAutocompleteDisabled()) {
                // autocompleteSettings['disabled'] = true;
                autocompleteSettings['getDataAsync'] = () => { };
            }

            this.widget.service['zone'].runOutsideAngular(() => {
                autocompleteSettings = this.adjustAutocompleteSettings(autocompleteSettings);
                if (settings.mode == 'advanced' || settings.mode == 'minimal') {
                    var addSelectedToTable = settings.enableLayouts && settings.addSelectedToTable;
                    if (addSelectedToTable) {
                        var tableForSelectedField = this.getTableForSelectedField(settings);
                        if (!tableForSelectedField) {
                            addSelectedToTable = false;
                        }
                    }

                    var queryBarSettings = {
                        mode: this.widget.settings.mode,
                        enableLayouts: settings.enableLayouts,
                        autocomplete: autocompleteSettings,
                        showFieldselector: true,
                        addSelectedToTable: addSelectedToTable ? (fields) => {
                            var vizW = this.getTableForSelectedField(this.widget.settings);
                            var vizTable = vizW.data.table;
                            var columnSelector = vizTable.columnSelector;
                            if (columnSelector) {
                                fields.forEach(f => {
                                    if (!columnSelector.isColumnVisible({
                                        field: f
                                    })) {
                                        columnSelector.addColumn({
                                            field: f
                                        });
                                    }
                                });
                                columnSelector.refreshCache();
                                this.widget.service.setState(true);
                            }
                        } : null,
                        getTableFields: addSelectedToTable ? () => {
                            var vizW = this.getTableForSelectedField(this.widget.settings);
                            var vizTable = vizW.data.table;
                            return vizTable.columns ? vizTable.columns.map(col => col.field) : [];
                        } : null,
                        filtersChanged: (filters) => {
                            this.widget.service['zone'].run(() => {
                                this.filtersChanged(filters);
                            });
                        },
                        /**
                         * UI changed
                         */
                        refreshUI: (filter) => {
                            this.widget.service['zone'].run(() => {
                                this.refreshUI(filter);
                            });
                        },
                        /**
                         * Search text changed
                         */
                        searchTextChanged: () => {
                        },

                        /**
                         * Get querybar mode
                         * undefined - 'filters' mode if available, otherwise - 'sjql' mode
                         * 'sjql' - if filters mode available, but user selected 'sjql' mode
                         */
                        getPreferedMode: () => {
                            return this.widget.state.mode;
                        },
                        /**
                         * Get querybar filters
                         */
                        getFilters: () => {
                            var res = this.widget.state.filters;
                            if (res) {
                                res = res.slice();
                            }
                            return res || [];
                        },
                        /**
                         * On suggestion closed
                         */
                        suggestionClosed: () => {
                            this.suggestionClosed();
                        },
                        getDefaultFields: () => {
                            var viewDefaultFields = this.widget.service.seriesParam.default_fields;
                            if (viewDefaultFields) {
                                if (typeof viewDefaultFields == 'function') {
                                    viewDefaultFields = viewDefaultFields(this.widget.service);
                                }
                                if (viewDefaultFields) {
                                    return viewDefaultFields.split(',');
                                }
                            }
                            var accountDefaultFields = window['SHOOJU_CONFIG']?.default_fields || [];

                            // rename ^fields. to blank (remove)
                            // rename ^series_id to sid
                            // remove  ^idterms completely – I can’t think of good way to explain this 
                            accountDefaultFields = accountDefaultFields
                                .map(f => {
                                    switch (f) {
                                        case 'series_id':
                                            return 'sid';
                                        default:
                                            if (f && f.indexOf('fields.') == 0) {
                                                return f.substr(7);
                                            }
                                            if (f && f.indexOf('idterms') == 0) {
                                                return null;
                                            }
                                            if (f && (f.indexOf('series_id.') == 0 || f.indexOf('series_id^') == 0)) {
                                                return `sid${f.substr(9)}`;
                                            }
                                            return f;
                                    }
                                }).filter(f => f);
                            return accountDefaultFields;
                        },
                        fields_service: this.widget.service.sharedServices.fields,
                    }

                    queryBarSettings = this.adjustQueryBarSettings(queryBarSettings);
                    this.$el['sjquerybar'](queryBarSettings);

                    if (settings.enableLayouts) {
                        this.widget.on('stateChange', (w, newVal, oldVal) => {
                            if (this.$el && newVal && oldVal && (newVal.searchString != oldVal.searchString ||
                                JSON.stringify(newVal.filters || null) != JSON.stringify(oldVal.filters || null))) {
                                setTimeout(() => {
                                    this.forceRefresh();
                                });
                            }
                        });
                    }
                } else {
                    this.$el['sjautocomplete'](autocompleteSettings);
                    this.widget.on('stateChange', (w, newVal, oldVal) => {
                        if (this.$el && newVal && oldVal && (newVal.searchString != oldVal.searchString)) {
                            setTimeout(() => {
                                this.forceRefresh();
                            });
                        }
                    });
                }
                this.afterAutocompleteCreated();
                this.refreshTextareaSizeWithTimeout();

                this.autocompleteSettings = autocompleteSettings;
            });

        }, err => {
            console.log('Search Widget: jQuery is not available.');
        });

        // }
    }

    /**
     * Triggered when suggestion has been closed
     */
    suggestionClosed() {
        this.suggestionWasClosed = true;
    }

    filtersChanged(filters) {
        if (JSON.stringify(this.widget.state.filters || []) != JSON.stringify(filters || [])) {
            this.widget.state.filters = filters || [];
            this.widget.service.setState(true);
        }
    }

    /**
     * Triggered when something changed on UI
     */
    refreshUI(filter) {

    }

    /**
     * Triggered right after autocomplete/querybar creation
     */
    afterAutocompleteCreated() {

    }

    forceRefresh() {
        if (this.widget.settings.mode == 'advanced' || this.widget.settings.mode == 'minimal') {
            if (this.widget.settings.enableLayouts) {
                var sjquerybar = this.$el.data('sjquerybar');
                if (sjquerybar) {
                    sjquerybar.applyQuery(this.widget.state.searchString);
                }
            }
        } else {
            var sjautocomplete = this.$el.data('sjautocomplete');
            if (sjautocomplete) {
                sjautocomplete.queryChanged();
            }
        }
    }

    getTableForSelectedField(settings) {
        var vizWidgets = this.widget.service.getAllWidgets().filter(w => {
            return w.type == 'viz' && w.settings.table.show_column_selector;
        });
        if (settings.addSelectedToTableId) {
            vizWidgets = vizWidgets.filter(w => {
                return w.id == settings.addSelectedToTableId;
            });
        }
        return vizWidgets.length == 1 ? vizWidgets[0] : null;
    }

    /**
     * Set querybar suggestions from api response
     */
    setSuggestionsFromResponse(data: IDataResponse) {
        if (this.widget.settings.suggest && this.widget.state.searchString && !this.suggestionWasClosed) {
            this.setSuggestions(data.suggest);
        }
    }

    /**
     * Set querybar suggestions
     */
    setSuggestions(suggestions) {
        if (this.$el && this.$el.data) {
            var sjquerybar = this.$el.data('sjquerybar');
            if (sjquerybar) {
                sjquerybar.setSuggestions(suggestions);
            }
            var sjautocomplete = this.$el.data('sjautocomplete');
            if (sjautocomplete) {
                sjautocomplete.setSuggestions(suggestions);
            }
        }
    }

    // called outside of sjsearch to refresh internal widget data which may rely on settings
    // returns promise or null
    settingsChanged() {
        this.initAutocomplete();
    }

    // can be used outside to override autocomplete settings
    adjustAutocompleteSettings(settings) {
        return settings;
    }

    // can be used outside to override querybar settings
    adjustQueryBarSettings(settings) {
        return settings;
    }

    destroyAutocomplete() {
        this.widget.service['zone'].runOutsideAngular(() => {
            if (this.$el && this.$el.data('sjautocomplete')) {
                this.$el['sjautocomplete']('destroy');
                delete this.$el.data()['sjautocomplete'];
            }
            if (this.$el && this.$el.data('sjquerybar')) {
                this.$el['sjquerybar']('destroy');
                delete this.$el.data()['sjquerybar'];
            }
        });
    }

    destroy() {
        this.destroyAutocomplete();
    }

    afterInit() {
        this.formatQuery(this.widget.state.searchString).then(q => {
            this.lastQuery = q;
        });
        this.widget.on('stateSet', () => {
            // reset `lastQuery` if widget's state is changed from outside
            this.formatQuery(this.widget.state.searchString).then(query => {
                if (this.lastQuery !== query) {
                    this.lastQuery = null;
                }
            });
        });

        // There could be two search widgets on the page (e.g. for desktop and mobile layouts)
        // but there should be only one GA event in this case
        if (this.sendInitialSearchTrackEvent) {
            this.sendInitialSearchTrackEvent = false;

            var searchWidgets = this.widget.service.getAllWidgets().filter(function (w) {
                return w.type == 'fuse-search' || w.type == 'search';
            });
            if (searchWidgets.length > 1) {
                var isCurrentWidgetVisible = !!this.widget.widgetDiv.element.nativeElement.offsetParent;
                if (!isCurrentWidgetVisible) {
                    return;
                } else {
                    // This search widget not shown on the page, so there should be another search widget 
                    // which is shown and event should be sent by it
                    debugger;
                }
            }

            var cfg = this.widget.service.getConfig();
            if (cfg && cfg.trackAction) {
                cfg.trackAction('search:search', this.widget, {
                    keyword: this.widget.state.searchString || ''
                });
            }
        }
    }

    formatQuery(q): Promise<string> {
        return new Promise<string>(resolve => {
            var globalQ = this.widget.s.awaitGlobalQuery(this.widget, true, false);
            var globalOp = this.widget.s.awaitGlobalQueryOperators(this.widget);

            Promise.all([globalQ, globalOp]).then(([baseQ, op]) => {
                var parts = [];
                if (baseQ) {
                    parts.push(baseQ);
                }
                if (q) {
                    parts.push(q);
                }

                var result = parts.join(' ');

                if (op) {
                    result += op;
                }

                resolve(result);
            });
        });
    }

    focus(e) {
        this.selected = true;
    }

    mouseenter(enter) {
        this.mouseover = enter;
    }

    blur(e) {
        if (!this.mouseover) {
            this.widget.service.waitForJQuery().then(jQuery => {
                var $el = jQuery(e.relatedTarget);
                var wrapperId = this.autocompleteSettings?.classNames?.searchResultsWrapperId || 'sj-searchResults-wrapper';
                var insideAc = $el.closest('#' + wrapperId).length;
                if (!insideAc) {
                    this.selected = false;
                    if (this.widget.settings.mode != 'advanced' && this.widget.settings.mode != 'minimal') {
                        this.onSearch();
                    }
                    this.refreshTextareaSizeWithTimeout();
                }
            }, () => {
                console.log('Search Widget: jQuery is not available.');
            });
        }
    }

    onSubmit() {
        this.onSearch();
        this.widget.service.waitForJQuery().then(jQuery => {
            this.$textarea.trigger('hide');
        });
    }

    onSearch() {
        this.formatQuery(this.widget.state.searchString).then(query => {

            var stateModeChanged = false;
            if (this.widget.settings.mode == 'advanced' || this.widget.settings.mode == 'minimal') {
                if (this.widget.settings.enableLayouts) {
                    stateModeChanged = this.refreshModeState();
                }
            }

            if (this.lastQuery === query) {
                if (stateModeChanged) {
                    this.widget.service.setState(true);
                }
                return;
            }
            this.suggestionWasClosed = null;
            this.lastQuery = query;
            this.triggerSearch();
        });
    }

    triggerSearch() {
        this.widget.service.setState();
        this.widget.service.getConfig().trackAction('search:search', this.widget, {
            keyword: this.widget.state.searchString || ''
        });
    }

    keydown(e) {
        if (e.keyCode === 13) {
            this.onSearch();
            e.preventDefault();
        }
        setTimeout(() => {
            this.refreshTextareaSize();
        });
    }

    refreshTextareaSize() {
        if (this.widget.settings.resize !== false && this.$textarea && this.$textarea[0]) {
            this.$textarea[0].style.overflow = 'hidden';
            this.$textarea[0].style.height = 'auto';
            if (this.$textarea[0].scrollHeight) {
                this.$textarea[0].style.height = this.$textarea[0].scrollHeight + "px";
            }
        }
    }

    refreshTextareaSizeWithTimeout() {
        if (this.widget.settings.resize !== false) {
            clearTimeout(this.refreshTimeout);
            this.refreshTimeout = setTimeout(() => {
                this.refreshTextareaSize();
            }, 400);
        }
    }

    cleanQuery(uncleaned_query) {
        if (!uncleaned_query)
            return uncleaned_query;

        // helper functions
        var endsWith = function (str, suffix) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        };
        var startsWith = function (str, suffix) {
            return str.indexOf(suffix) == 0;
        };

        var cleanQuoted = function (mightBeQuoted) {
            //input: text that might have quotes in it
            //output: text that retains the parts in quotes and cleans everything else using cleanUnquoted()
            if (mightBeQuoted.length < 3) {
                return cleanUnquoted(mightBeQuoted).trim();
            }
            var res = mightBeQuoted.replace(/(.*)([\s\:\=\<\>]+)(\"[^"]+\")([\s\:\=\<\>]*)(.*)/, '$1\n$2\n$3\n$4\n$5').split('\n');
            if (res.length == 1) { //case when quotes are right away in beginning
                res = mightBeQuoted.replace(/^(\"[^"]+\")([\s\:\=\<\>]*)(.*)/, '$1\n$2\n$3').split('\n');
            }
            //left - guaranteed to be quote-free
            //quoteSeparator -- optional
            //quoted -- leave it alone
            //quoteSeparator -- optional
            //right -- might have some quotes
            if (res.length == 1) {
                return cleanUnquoted(mightBeQuoted).trim();
            } else if (res.length == 5) {
                return cleanUnquoted(res[0]) + res[1] + res[2] + res[3] + cleanQuoted(res[4]).trim();
            } else if (res.length == 3) {
                return res[0] + res[1] + cleanQuoted(res[2]).trim();
            } else {
                return 'impossible!?';
            }
        }

        var cleanUnquoted = function (queryDirty) {
            //input: dirty text without quotes
            //output: clean text
            var query = queryDirty;

            var endswithspace = endsWith(query, ' ');
            var startswithspace = startsWith(query, ' ');
            //pad the query ... makes some things easier below
            query = ' ' + query + ' ';

            //reduce number of :/=
            query = query.replace(/:+/, ':').replace(/=+/, '=');

            // clean :/= if has space behind without quote
            query = query.replace(/(:|=)(\s+?\w)/, '$2');

            // reduce whitespaces
            query = query.replace(/(\r|\n|\t|\s)+/, ' ');

            //if no alpha and num return ''
            if (query.search(/[^\&\(\)\|\:\=]/) == -1) {
                return '';
            }

            // remove specials
            var remove_special_words = function (query_in) {
                query_in = query_in.replace(' && ', ' ');
                query_in = query_in.replace(' || ', ' ');
                query_in = query_in.replace(' & ', ' ');
                query_in = query_in.replace(' or ', ' ');
                query_in = query_in.replace('(', ' ');
                query_in = query_in.replace(')', ' ');
                query_in = query_in.replace(' not ', ' ');
                query_in = query_in.replace(/ and /i, ' ');
                query_in = query_in.replace(/^ *OR /, ' ');
                query_in = query_in.replace(/ OR *$/, ' ');
                return query_in;
            }
            while (true) {
                var changed = remove_special_words(query);
                if (changed == query) {
                    break;
                } else {
                    query = changed;
                }
            }

            //trimmer
            query = query.trim();

            //remove leading and trailing : -
            [':', '-'].forEach(function (s) {
                query = query.replace(new RegExp('^' + s), '');
                query = query.replace(new RegExp(s + '$'), '');
            });

            query = (startswithspace ? ' ' : '') + query + (endswithspace ? ' ' : '');

            return query;
        }

        return cleanQuoted(uncleaned_query);

    }


    getUrlParam(paramName) {
        var params = this.widget.service.getUrlParams();
        return params[paramName];
    }

    getUrlParamName() {
        return ((this.widget.settings.urlParam === true ? 'query' : this.widget.settings.urlParam) || ''); //.toLowerCase();
    }

    getUrlValue() {
        return this.widget.state.searchString;
    }

    getStateWithoutUrlParam() {
        var state = JSON.parse(JSON.stringify(this.widget.state || {}));
        delete state.searchString;
        delete state.widgetName;

        if (state.filters && !state.filters.length) {
            delete state.filters;
        }

        if (!Object.keys(state).length) {
            return null;
        }

        return state;
    }

    setSelectedFromUrlParams() {

        if (this.widget.settings.urlParam) {
            var paramName = this.getUrlParamName();
            if (paramName) {
                var param = this.getUrlParam(paramName);
                if (param) {
                    if (!this.widget.service.stateService?.getSavedWidgetState(this.widget.id)) {
                        this.widget.state.searchString = param;
                    }
                }
            }
        }
    }

    stateInit() {
        this.setSelectedFromUrlParams();

        if (this.widget.state?.searchString) {
            this.sendInitialSearchTrackEvent = true;
        }
    }

    getQuery() {
        var searchString = this.widget.state.searchString;
        if (this.widget.settings.mode !== 'advanced' && this.widget.settings.mode !== 'minimal' && this.widget.settings.clean) {
            return this.widget.data.cleanQuery(searchString);
        }
        if (searchString) {
            return searchString.trim();
        }
    }

    beforeSearch(args) {
        // update lastQuery as it can be changed in getQuery from other widgets
        this.formatQuery(this.widget.state.searchString).then(q => {
            this.lastQuery = q;
        });

        // suggestions
        if (this.widget.settings.suggest) {
            if (this.widget.state.searchString) {
                args.suggest = this.widget.state.searchString;
                if (this.widget.settings.suggest_filter) {
                    let suggest_filter = this.widget.settings.suggest_filter;
                    if (typeof suggest_filter == 'function') {
                        suggest_filter = suggest_filter(this.widget);
                    }
                    if (suggest_filter) {
                        args.suggest_filter = suggest_filter;
                    }
                } else {
                    let suggest_filter = this.widget.service.getGlobalOptions().filter_query;
                    if (suggest_filter) {
                        args.suggest_filter = suggest_filter;
                    }
                }
                if (this.widget.settings.suggest_fields) {
                    var suggest_fields = this.widget.settings.suggest_fields;
                    if (typeof suggest_fields == 'function') {
                        suggest_fields = suggest_fields(this.widget);
                    }
                    if (suggest_fields) {
                        args.suggest_fields = suggest_fields;
                    }
                } else {
                    if (args.default_fields) {
                        args.suggest_fields = args.default_fields;
                    }
                }
            }
            this.setSuggestions(null);
        }
    }

    onData(data) {
        // update lastQuery as it can be changed in getQuery from other widgets
        this.formatQuery(this.widget.state.searchString).then(q => {
            this.lastQuery = q;
        });

        this.refreshTextareaSizeWithTimeout();
        this.setSuggestionsFromResponse(data);
    }
}

export const SearchWidgetDefinition: IWidgetDefinition<SearchData, ISearchSettings, ISearchState> = {
    init(widget) {
        widget.data = new SearchData(widget);
    },
    afterInit(widget) {
        widget.data.afterInit();
    },
    defaultState: {
        searchString: '',
        filters: []
    },
    getQuery(widget) {
        return widget.data.getQuery();
    },
    beforeSearch(widget, args) {
        return widget.data.beforeSearch(args);
    },
    onData(widget, data) {
        widget.data.onData(data);
    },
    stateInit(widget) {
        widget.data.stateInit();
    },
    destroy(widget) {
        widget.data.destroy && widget.data.destroy();
    },
    template: template,
    styles: styles
}
